<template lang="pug">
v-container
  .middle 
    v-card.mx-auto.rounded-lg(max-width="100%", elevation="10")
      v-card-title APIs
      v-card-text
        v-divider
        v-container          
          v-row(align="center", justify="space-around" style="height: 160px;")
              v-btn.nufi-btn(depressed @click="openLink('http://nufi.productboard.mx')")  
                v-html {{ $t('tryapis') }}
              v-btn.nufi-btn(depressed @click="$router.push({name: 'apis'})")
                v-html {{ $t('knowyourkeys') }}
              v-btn.nufi-btn(depressed @click="$router.push({name: 'apis'})") {{ $t('nufipostman') }}
</template>
<script>
import link from '@/mixins/link';

export default {
  mixins: [link],
}
</script>